<template>
  <div class="container">
    <div class="text-end p-3">
      <c-primary-button to="/admin/configuraciones/perfiles/crear">
        Crear Perfil
      </c-primary-button>
    </div>
    <c-card title="Perfiles">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Perfil</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="profile in profiles" :key="profile.id">
            <td>{{ profile.name }}</td>
            <td class="text-nowrap">
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/perfiles/${profile.id}/marcos-legales-generales`"
                title="Marcos legales generales"
                ><i class="fa-solid fa-list-ol"></i
              ></router-link>
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/perfiles/${profile.id}/editar`"
                title="Editar"
                ><i class="fa-solid fa-pen"></i
              ></router-link>
              <a
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                href="javascript:void(0)"
                @click="deleteProfile(profile.id)"
                title="Eliminar"
                ><i class="fa-solid fa-trash-can"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import { all, remove } from "@/services/profiles";
import { showNotification } from "@/services/notification";

export default {
  components: {
    CCard,
    CPrimaryButton,
  },
  data() {
    return {
      profiles: [],
    };
  },
  mounted() {
    this.getProfiles();
  },
  methods: {
    getProfiles() {
      all()
        .then((response) => {
          this.profiles = response.data;
        })
        .catch(() => {
          alert("No pudimos cargar los perfiles");
        });
    },
    deleteProfile(id) {
      const removeRecord = confirm("¿Estás seguro de eliminar el registro?");
      if (!removeRecord) {
        return;
      }
      remove(id).then(() => {
        showNotification(204, "success", "El registro fue eliminado.");
        this.getProfiles();
      });
    },
  },
};
</script>
